module.exports = __webpack_public_path__ + "static/jallosh-4d79ae833d9f46fc13590b536daca1d8.png";